import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

  constructor(private toastController: ToastController) {}

  handleError(error: Error) {
    if (error instanceof HttpErrorResponse){
      if(error.status === 500){
        this.presentToast('Sorry. Something went wrong. Please try again later');
      } else if(error.error? error.error?.message || error.error?.Message: error.message) {
        const message = error.error? error.error.message || error.error.Message: error.message;
        this.presentToast(message);
      } else {
        this.presentToast('Sorry. Service is not available. Please try again later');
      }
    } else {
      if (error.toString() !== 'cordova_not_available'){
       if (error.message) {
        this.presentToast('Sorry. Something went wrong. Please try again later.');
        throw new Error();
      }
    }
  }
  }

  private async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000
    });
    toast.present();
  }

}
